import { Plan } from '.';
import dayjs from 'dayjs';
import { CoachingPayment } from './coaching_payment';
export const PaymentChannel = {
    MEGALOS: 'megalos',
    APPSTORE: 'appstore',
    STRIPE: 'stripe',
    EMPLOYEE_WELFARE: 'employee_welfare',
    COLLABORATION: 'collaboration',
    AMAZON_PAY: 'amazon_pay',
    None: 'none',
};
export const CollaborationServiceName = {
    WECLE: 'wecle',
    MEGALOS: 'megalos',
};
export class Payment {
    constructor(payment, config) {
        Object.defineProperty(this, "cardLastFour", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "subPlanId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "curPeriodStartTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "curPeriodEndTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "trialEndTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "curPeriodEndDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "paymentChannel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tieUpPlanType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentPlan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queuedPlan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "corporationEmployee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isExpired", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "collaborationUserPayment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freeTrialEndAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dormantPeriodEnd", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isMegalosUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isBillingGrace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "coachingPayment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cardLastFour = payment.cardLastFour;
        this.subPlanId = payment.subPlanId;
        this.curPeriodStartTime = payment.curPeriodStartTime;
        this.curPeriodEndTime = payment.curPeriodEndTime;
        this.trialEndTime = payment.trialEndTime; // 休眠はTrialEndを変更することで実現しているので、フロントでtrialEndTimeを利用する場合は注意が必要
        this.paymentChannel = payment.paymentChannel;
        this.tieUpPlanType = payment.tieUpPlanType;
        this.currentPlan = new Plan(payment.currentPlan, config);
        this.queuedPlan = payment.queuedPlan ? new Plan(payment.queuedPlan, config) : null;
        this.corporationEmployee = payment.corporationEmployee;
        this.collaborationUserPayment = payment.collaborationUserPayment;
        this.curPeriodEndDate = new Date(this.curPeriodEndTime * 1000);
        this.isExpired = payment.isExpired;
        this.freeTrialEndAt = payment.freeTrialEndAt || 0;
        this.dormantPeriodEnd = dayjs.unix(payment.dormantPeriodEnd);
        this.isMegalosUser = payment.isMegalosUser;
        this.isBillingGrace = payment.isBillingGrace;
        this.coachingPayment = payment.coachingPayment ? new CoachingPayment(payment.coachingPayment) : null;
    }
    get curPeriodEndFormattedDate() {
        const endDate = this.curPeriodEndDate;
        return `${endDate.getFullYear()}/${endDate.getMonth() + 1}/${endDate.getDate()}`;
    }
    get coachingPaymentAvailable() {
        return this.isStripePayment() || this.isAmazonPayUser();
    }
    isAppstorePayment() {
        return this.paymentChannel === PaymentChannel.APPSTORE;
    }
    isStripePayment() {
        return this.paymentChannel === PaymentChannel.STRIPE;
    }
    // メガロス店舗で登録したユーザーかどうか
    isMegalosOptionUser() {
        return this.paymentChannel === PaymentChannel.MEGALOS;
    }
    // 弊社のメガロスプランを登録したユーザーかどうか
    isMegalosPlanUser() {
        return this.tieUpPlanType === PaymentChannel.MEGALOS;
    }
    // 福利厚生ユーザーかどうか
    isEmployeeWelfareUser() {
        return this.paymentChannel === PaymentChannel.EMPLOYEE_WELFARE;
    }
    // 協業ユーザーかどうか
    isCollaborationUser() {
        return this.paymentChannel === PaymentChannel.COLLABORATION;
    }
    // 引数で渡された支払いチャネルと現在の支払いチャネルが一致しているかどうか
    isPaymentChannelMatched(...paymentChannel) {
        return paymentChannel.includes(this.paymentChannel);
    }
    isAmazonPayUser() {
        return this.paymentChannel === PaymentChannel.AMAZON_PAY;
    }
    // 法人ユーザーかどうか
    isCorporationUser() {
        return !!this.corporationEmployee;
    }
    isFreeTrialUser() {
        return this.freeTrialEndAt > new Date().getTime() / 1000;
    }
    isExpirationDateNearThanCoachingPayment(coaching) {
        if (!coaching)
            return false;
        return this.curPeriodEndTime < coaching.curPeriodEnd;
    }
    periodEndDiffFromNow() {
        return Math.abs(dayjs().diff(this.curPeriodEndDate, 'day'));
    }
}
